module.exports = __webpack_public_path__ + "fonts/mc.f87a0ce.ttf";